import * as tslib_1 from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
var owaHeaderStyles = require('owa-header/lib/components/Header.scss');
var OwaSuiteHeaderButton = /** @class */ (function (_super) {
    tslib_1.__extends(OwaSuiteHeaderButton, _super);
    function OwaSuiteHeaderButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OwaSuiteHeaderButton.prototype.render = function () {
        return (React.createElement("div", { className: this.state && this.state.searchMode && owaHeaderStyles.inSearch }, this.props.children));
    };
    OwaSuiteHeaderButton = tslib_1.__decorate([
        observer
    ], OwaSuiteHeaderButton);
    return OwaSuiteHeaderButton;
}(React.Component));
export default OwaSuiteHeaderButton;
//# sourceMappingURL=OwaSuiteHeaderButton.js.map